import {isRouteErrorResponse, useRouteError} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {ErrorTemplate} from '@sdox/ui'
import {IS_DEV, IS_STAGING} from '@sdox/utils/dom'

import type {ErrorTemplateProps} from '@sdox/ui'

export const ErrorBoundary = () => {
  const {t} = useTranslation()
  const error = useRouteError()

  let props: ErrorTemplateProps = {
    title: t('common:error.emoji'),
    description: t('common:error.unknown'),
    code: IS_STAGING || IS_DEV ? JSON.stringify(error, null, 2) : undefined,
  }

  // this is ugly, but a custom thrown json is not a routeErrorResponse (these are only thrown by loaders?)
  if (isRouteErrorResponse(error) || ('object' === typeof error && error && 'status' in error)) {
    if (error.status === 404) {
      props = {
        ...props,
        title: t('common:notFound.emoji'),
        description: t('common:notFound.exposeFolder'),
      }
    }

    if (error.status === 422) {
      props = {
        ...props,
        title: t('common:parameter.emoji'),
        description: t('common:parameter.incomplete'),
      }
    }

    if (error.status === 401) {
      props = {
        ...props,
        title: t('common:notAuthorized.emoji'),
        description: t('common:notAuthorized.document'),
      }
    }

    if (error.status === 503) {
      props = {
        ...props,
        title: t('common:api.emoji'),
        description: t('common:api.unknown'),
      }
    }

    if (error.status === 418) {
      props = {
        ...props,
        title: t('common:honeypot.emoji'),
        description: t('common:honeypot.text'),
      }
    }
  }

  return <ErrorTemplate {...props} />
}
